import { FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import { ChangeEvent, createElement, FC } from 'react';

import { DynamicSchemaDefinitionSelectOne } from '../../../../../generated/graphql';
import { SelectOneValue } from '../../../../types/DynamicSchema';
import LfToBr from '../../../primitive/LfToBr';
import Base from './Base';

type Props = {
  field: DynamicSchemaDefinitionSelectOne;
  value: SelectOneValue;
  onChange: (e: ChangeEvent<HTMLInputElement>, value: SelectOneValue) => void;
  className?: string;
};

const SelectOneField: FC<Props> = ({ field, value, onChange, className }) => {
  const items = field.choices.map((choice) => (
    <FormControlLabel
      control={<Radio />}
      value={choice.key}
      label={<Typography variant="body2">{choice.label}</Typography>}
      key={choice.key}
    />
  ));

  return (
    <Base field={field} labelPaddingTop={14} className={className}>
      <div>
        <RadioGroup onChange={onChange} value={value}>
          {items}
        </RadioGroup>

        <Typography variant="caption">
          <LfToBr text={field.helperText} />
        </Typography>
      </div>
    </Base>
  );
};

export default SelectOneField;
